import { css } from "@compiled/react";

import { Header, HeroCards } from "./";

export const HeroSection = () => {
    const headerContent = {
        mainHeading: "Great outcomes start with Jira",
        subHeading:
            "The #1 project management tool for high-performing teams. Flexible for the work you do, connected to everything.",
        buttonText: "Get Jira Free"
    };

    const heroStyles = css({
        background: "#F4F5F7",
        width: "100%"
    });

    return (
        <div css={heroStyles}>
            <Header {...headerContent} />
            <HeroCards />
        </div>
    );
};

HeroSection.displayName = "HeroSection";
